module.exports = __webpack_public_path__ + "img/FAS_FantasyAxe_Unity.ed2c00ce.png";